<template>
    <div class="md-layout">
      <div class="md-layout-item start-project">
          <form>
            <div class="md-layout start-inputs">
              <md-field class="md-layout-item md-size-100">
                <label>Facility Name</label>
                <md-input v-model="newFacility.name" required type="text"></md-input>
              </md-field>
              <AutoCompleteInput v-on:childToParent="onChildClick" v-bind:facility="true" />
              <md-field class="md-layout-item md-size-45 md-medium-size-100">
                <label>Facility Second Street Address</label>
                <md-input v-model="newFacility.address_attributes.address_line_2" type="text"></md-input>
              </md-field>
              <md-field class="md-layout-item md-size-45 md-medium-size-100">
                <label>Facility City</label>
                <md-input v-model="newFacility.address_attributes.city" required type="text"></md-input>
              </md-field>
              <md-field class="md-layout-item md-size-45 md-medium-size-100">
                <label>Facility State</label>
                <md-input v-model="newFacility.address_attributes.state" required type="text"></md-input>
              </md-field>
              <md-field class="md-layout-item md-size-45 md-medium-size-100">
                <label>Facility Zip Code</label>
                <md-input v-model="newFacility.address_attributes.zip_code" required type="text"></md-input>
              </md-field>
              <!-- <md-field class="md-layout-item md-size-100">
              <label>Main Facility Contact First and Last Name</label>
              <md-input v-model="newFacility.company_contact" required type="text"></md-input>
            </md-field>
            <md-field class="md-layout-item md-size-100">
              <label>Main Facility Contact Email</label>
              <md-input v-model="newFacility.company_contact_email" required type="text"></md-input>
            </md-field> -->
            </div>
            <md-card-actions md-alignment="right">
              <md-button class="md-success" v-on:click="addFacility">Add New Facility</md-button>
            </md-card-actions>
          </form>
      </div>
    </div>
</template>
<script>
import api from '@/api';
import AutoCompleteInput from '@/pages/Dashboard/ProjectPages/Components/AutoCompleteInput.vue';
export default {
  components: {
    AutoCompleteInput
  },
  props: ['company'],
  data() {
    return {
      currentStep: 1,
      newFacilityId: '',
      newFacility: {
        address_attributes: {
          street_address: '',
          address_line_2: '',
          city: '',
          state: '',
          zip_code: '',
          country: 'United States'
        },
        name: '',
        company_id: this.company
      }
    }
  },
  methods: {
    addFacility() {
      var co = {
        "facility": this.newFacility
      }
      console.log('newFacility', co)
      api.createFacility(co).then((response) => {
        this.notifyVue(`You have added a new facility ${this.newFacility.name}.`);
        console.log('response data', response)
        this.$emit('childToParent', response.data)
        // this.newFacilityId = response.data.company_id;
        // this.$router.push(`/editcompany/${this.newFacilityId}`)
        // this.currentStep = 2;
      })
    },
    notifyVue(message) {
      this.$notify({
        timeout: 2500,
        message: message,
        icon: "done_all",
        horizontalAlign: "left",
        verticalAlign: "top",
        type: "success"
      });
    },
    onChildClick(value) {
      this.newFacility.address_attributes.street_address = value[0].long_name + ' ' + value[1].long_name;
      this.newFacility.address_attributes.city = value[3].long_name;
      this.newFacility.address_attributes.state = value[5].long_name;
      this.newFacility.address_attributes.zip_code = value[7].long_name;
    }
  },
  watch: {
    nuOfUsers: function (val) {
      var uObj = {
        first_name: '',
        last_name: '',
        email: ''
      }
      if (this.nuOfUsers > 0 && this.nuOfUsers >= this.newUsers.length) {
        this.newUsers.push(uObj);
      } else if (this.nuOfUsers > 0) {
        this.newUsers.pop();
      }
    }
  }
};
</script>
<style lang="scss">
.extra-users {
  width: 100%;
}

.employee-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-around;

  .md-layout-item {
    // display: inline-block;
  }
}
</style>
